import React, { useEffect, useState } from "react";
import { jsPDF } from "jspdf";
import i18next from 'i18next'
import { authAxios } from "../config/config";
import { toast } from "react-toastify";
import IsLoadingHOC from "../Common/IsLoadingHOC";
import {
  BudgetFormat,
  getFormatedDate,
  setReportFormatDate,
  showLimitedText,
} from "../Helper/helper";
import { Link } from "react-router-dom";
import { FaChevronDown, FaEye } from "react-icons/fa";
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import {
  ArchiveBoxXMarkIcon,
  ChevronDownIcon,
  PencilIcon,
  Square2StackIcon,
  TrashIcon,
} from '@heroicons/react/16/solid'
import { IoMdMore } from "react-icons/io";
import Pagination from "../Common/Pagination";
import { useSelector } from "react-redux";
import DeleteConfirmationModel from "./Models/DeleteConfirmationModel";
import { FiPlus } from "react-icons/fi";
import AddBlogModel from "./Models/AddBlogModel";
import AddCountryModel from "./Models/AddCountryModel";
import AddTestModel from "./Models/AddTestModel";
import AddPatient from "./Models/AddPatient";
import { useTranslation } from "react-i18next";
import IsLoggedinHOC from "../Common/IsLoggedInHOC";

const Patient = (props) => {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  const { setLoading } = props;
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage, setPostsPerPage] = useState(5);
  const [totalPosts, setTotalPosts] = useState(5);

  const [allmodel, setallmodel] = useState({
    data: [],
    showDeleteModal: false,
    showAddModal: false,
  });

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const fetchAllData = async () => {
    setLoading(true);
    try {
      const response = await authAxios().get(
        `/admin/patient?page=${currentPage}&limit=${postsPerPage}`
      );
      setLoading(false);
      console.log(response);
      const resData = response?.data;
      setData(resData.data.patients);
      setTotalPosts(resData.data.totalPatients);
    } catch (error) {
      setLoading(false);
      toast.error(error?.response?.data?.message);
    }
  };
  const generatePDF = async (patientData) => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const marginLeft = 20;
    let currentY = 30;
  
    doc.setFontSize(18);
    doc.text("Patient Details", pageWidth / 2, currentY, { align: "center" });
    currentY += 10;
  
    const addDetail = (label, value) => {
      const wrappedText = doc.splitTextToSize(`${label}: ${value || "N/A"}`, pageWidth - 2 * marginLeft);
      doc.text(wrappedText, marginLeft, currentY);
      currentY += wrappedText.length * 6;
    };
  
    addDetail("Name", `${patientData.firstName} ${patientData.lastName}`);
    addDetail("Email", patientData.email);
    addDetail("Phone", patientData.phone);
    addDetail("Gender", patientData.gender);
    addDetail("Medical Case", patientData.medicalCase);
    currentY += 10;
  
    if (patientData.attachments.length > 0) {
      doc.setFontSize(14);
      doc.text("Attachments:", marginLeft, currentY);
      currentY += 10;
  
      for (let i = 0; i < patientData.attachments.length; i++) {
        const attachment = patientData.attachments[i];
        const fileUrl = `${process.env.REACT_APP_IMAGE_URL}/${attachment}`;
  
        if (attachment.toLowerCase().endsWith(".pdf")) {
          // Show PDF as a link
          doc.setTextColor(0, 0, 255);
          doc.textWithLink(`View PDF ${i + 1}`, marginLeft, currentY, { url: fileUrl });
          doc.setTextColor(0, 0, 0);
          currentY += 10;
        } else {
          // Show Image
          try {
            const imgData = await fetch(fileUrl)
              .then((response) => response.blob())
              .then(
                (blob) =>
                  new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = (err) => reject(err);
                    reader.readAsDataURL(blob);
                  })
              );
  
            const imgWidth = 100;
            const imgHeight = 80;
            const xPos = (pageWidth - imgWidth) / 2;
  
            doc.addImage(imgData, "JPEG", xPos, currentY, imgWidth, imgHeight);
            currentY += imgHeight + 10;
          } catch (error) {
            console.error("Failed to load image:", error);
            doc.text(`Failed to load image ${i + 1}`, marginLeft, currentY);
            currentY += 10;
          }
        }
      }
    }
    const fileName = `patient_${patientData.firstName}_${patientData.lastName}.pdf`;
    doc.save(fileName);
  };
  useEffect(() => {
    fetchAllData();
  }, [currentPage]);

  const handleCancel = () => {

    setallmodel((prev) => ({
      data: [],
      showDeleteModal: false,
      showAddModal: false,
    }))
  };

  const handleDelete = async () => {
    try {
      setLoading(true);
      await authAxios().delete(`/admin/patient/${allmodel.data._id}`);
      toast.success('Patient deleted successfully');
      handleCancel()
      fetchAllData();
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = async (newData) => {
    try {
      setLoading(true);
      await authAxios().post('/admin/patient', newData);
      toast.success('Patient added successfully');
      handleCancel()
      fetchAllData();
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = async (updatedData) => {
    try {
      setLoading(true);
      await authAxios().put(`/admin/patient/${allmodel.data._id}`, updatedData);
      toast.success('Patient updated successfully');
      handleCancel()
      fetchAllData();
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="px-12 py-6 bg-lightgray area--page pb-0">
        <div className="w-full mx-auto pb-16">
          <div className="flex mb-8 gap-5 items-center"></div>

          <div className="flex mb-[30px] gap-[20px] gap-y-[10px] md:items-center w-full md:justify-between md:flex-row flex-col-reverse ">

            <div className="flex gap-[5px] gap-y-[10px] flex-wrap w-full justify-end">
              <button className="flex items-center max-w-[140px] border border-white w-full justify-center bg-white text-textcolor py-[8px] px-[10px]  rounded-[5px] duration-[0.3s] hover:bg-transparent hover:border-textcolor hover:text-textcolor h-[45px] font-[600] min-h">
                Total : {totalPosts || 0}
              </button>

              <button
                onClick={() => setallmodel((prev) => ({
                  ...prev,
                  data: [],
                  showAddModal: true
                }))}
                className="flex items-center max-w-[160px] border border-buttonbg w-full justify-center bg-buttonbg text-white py-[8px] px-[15px]  rounded-[5px] duration-[0.3s] hover:bg-transparent hover:text-textcolor h-[45px] font-[600] min-h"
              >
                <FiPlus />
                Add
              </button>
            </div>
          </div>

          <div className="relative mt-2 overflow-x-auto px-5 py-4 bg-white rounded-t-md h-[100vh] over--scroller area--table">
            <table className="w-full text-sm text-left text-gray-500">
              <thead className="text-xs text-lightcolor border-b border-textcolor">
                <tr>
                  <th className="p-4 font-normal">S.no</th>
                  {/* <th className="p-4 font-normal">Image</th> */}
                  <th className="p-4 font-normal">Name</th>
                  <th className="p-4 font-normal">Email</th>
                  <th className="p-4 font-normal">Phone</th>
                  <th className="p-4 font-normal">Gender</th>
                  <th className="p-4 font-normal">Medical Case</th>
                  <th className="p-4 font-normal">Created At</th>
                  <th className="p-2 font-normal w-12">Actions</th>
                </tr>
              </thead>
              <tbody>
                {data &&
                  data.map((item, index) => (
                    <tr key={index} className="bg-white border-b hover:bg-gray-50">
                      <td className="px-5 py-5 border-b border-gray-200 text-sm">
                        <p className="whitespace-no-wrap text-textcolor">
                          {index + 1}
                        </p>
                      </td>
                      {/* <td className="px-5 py-5 border-b border-gray-200 text-sm">
                        <div className="flex items-center space-x-2">
                          {item?.attachments?.map((attachment, index) => (
                            <img
                              key={index}
                              className="w-10 h-10 rounded-full object-cover"
                              //   src={attachment}
                              src={`${process.env.REACT_APP_IMAGE_URL}/${attachment}`}

                              alt={`Attachment ${index + 1}`}
                            />
                          ))}
                        </div>
                      </td> */}

                      <td className="px-5 py-5 border-b border-gray-200 text-sm">
                        <p className="text-gray-900 whitespace-no-wrap">
                          {item.firstName} {item.lastName}
                        </p>
                      </td>
                      <td className="px-5 py-5 border-b border-gray-200 text-sm">
                        <p className="text-gray-900 whitespace-no-wrap">{item.email||"N/A"}</p>
                      </td>
                      <td className="px-5 py-5 border-b border-gray-200 text-sm">
                        <p className="text-gray-900 whitespace-no-wrap">{item.phone||"N/A"}</p>
                      </td>
                      <td className="px-5 py-5 border-b border-gray-200 text-sm">
                        <p className="text-gray-900 whitespace-no-wrap">{item.gender||"N/A"}</p>
                      </td>
                      {/* <td className="px-5 py-5 border-b border-gray-200 text-sm">
                        <p className="text-gray-900 whitespace-no-wrap">
                          {item.medicalCase||"N/A"}
                        </p>
                      </td> */}
                      <td className="px-5 py-5 border-b border-gray-200 text-sm max-w-[100px]">
                                              {/* <p className="text-gray-900 whitespace-no-wrap">
                                                {item?.content[currentlanguage]}
                                              </p> */}
                                             
                                              <div class='has-tooltip'>
                                                <span class='tooltip rounded shadow-lg p-1 bg-gray-100 text-black -mt-8'> {item.medicalCase||"N/A"}</span>
                                                 {
                                                  showLimitedText(item.medicalCase||"N/A")
                                                 }
                                              </div>
                      
                                            </td>
                      <td className="px-5 py-5 border-b border-gray-200 text-sm">
                        <p className="text-gray-900 whitespace-no-wrap">
                          {new Date(item.createdAt).toLocaleDateString()}
                        </p>
                      </td>
                      <td className="p-2 border-b border-gray-200 text-sm">
                        <Menu as="div" className="relative inline-block text-left">
                          <Menu.Button className="more--icon cursor-pointer w-8 h-8 bg-lightgray rounded-md flex items-center justify-center">
                            <IoMdMore />
                          </Menu.Button>
                          <Menu.Items className={`absolute ${isRTL ? "left-0" : "right-0"} z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black/5`}>
                            <div
                              onClick={() =>
                                setallmodel((prev) => ({
                                  ...prev,
                                  data: item,
                                  showAddModal: true,
                                }))
                              }
                              className="py-1"
                            >
                              <Menu.Item>
                                {({ active }) => (
                                  <a
                                    className={`block px-4 py-2 text-sm ${active
                                      ? 'bg-gray-100 text-gray-900'
                                      : 'text-gray-700'
                                      }`}
                                  >
                                    Edit
                                  </a>
                                )}
                              </Menu.Item>
                            </div>

                            <div
                              onClick={() =>
                                setallmodel((prev) => ({
                                  ...prev,
                                  data: item,
                                  showDeleteModal: true,
                                }))
                              }
                              className="py-1"
                            >
                              <Menu.Item>
                                {({ active }) => (
                                  <a
                                    className={`block px-4 py-2 text-sm ${active
                                      ? 'bg-gray-100 text-gray-900'
                                      : 'text-gray-700'
                                      }`}
                                  >
                                    Delete
                                  </a>
                                )}
                              </Menu.Item>
                            </div>

                            <Menu.Item>
                              {({ active }) => (
                                <a
                                  onClick={() => generatePDF(item)}  // Trigger the PDF generation
                                  className={`block px-4 py-2 text-sm ${active
                                    ? 'bg-gray-100 text-gray-900'
                                    : 'text-gray-700'
                                    }`}
                                >
                                  Download PDF
                                </a>
                              )}
                            </Menu.Item>
                          </Menu.Items>
                        </Menu>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <Pagination
            currentPage={currentPage}
            totalPosts={totalPosts}
            paginate={paginate}
            postsPerPage={postsPerPage}
            length={data?.length}
          />

          {allmodel.showDeleteModal && (
            <DeleteConfirmationModel
              handleCancel={handleCancel}
              handleDelete={handleDelete}
            />
          )}

          {allmodel.showAddModal && (
            <AddPatient
              handleCancel={handleCancel}
              handleAdd={handleAdd}
              allmodel={allmodel}
              handleUpdate={handleUpdate}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default IsLoggedinHOC(IsLoadingHOC(Patient));

